import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Music2 } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FCFCFD] grid place-items-center px-6">
      <div className="text-center">
        <div className="w-14 h-14 rounded-xl bg-[#0F172A] text-white grid place-items-center mx-auto">
          <Music2 className="w-6 h-6" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-bold tracking-tight">Page not found</h1>
        <p className="mt-2 text-slate-600">That page doesn't exist. Head back to the marketplace.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/explore"><Button className="bg-[#4F46E5] hover:bg-[#4338CA] text-white" data-testid="nf-explore">Go to Explore</Button></Link>
          <Link to="/"><Button variant="outline" data-testid="nf-home">Home</Button></Link>
        </div>
      </div>
    </div>
  );
}
